import { useEffect, useState } from 'react';
import UnosKoordinata from './UnosKoordinata';
import StatusTocke from './StatusTocke';
import PotvrdaUklanjanja from './PotvrdaUklanjanja';

/**
 * Kartica odabranog člana. Pozicija se postavlja isključivo upisom
 * koordinata i klikom na Potvrdi.
 */
export default function KarticaClana({
  clan,
  jeUprava,
  onSpremi,
  onPotvrdi,
  onUkloni,
  onZatvori,
}) {
  const [radi, setRadi] = useState(false);
  const [poruka, setPoruka] = useState(null);
  const [uklanja, postaviUklanja] = useState(false);

  useEffect(() => {
    setPoruka(null);
  }, [clan?.id]);

  if (!clan) return null;

  const pozovi = async (fn) => {
    setRadi(true);
    try {
      await fn(clan);
      postaviUklanja(false);
      setPoruka({ vrsta: 'ok', tekst: 'Promjena je spremljena.' });
    } catch (e) {
      setPoruka({ vrsta: 'greska', tekst: e.message });
    } finally {
      setRadi(false);
    }
  };

  const napomene = [];
  if (clan.status === 'predlozeno')
    napomene.push(
      jeUprava
        ? 'Točka je automatski geokodirana i nije provjerena. Usporedi s ortofotom pa potvrdi ili upiši točne koordinate.'
        : 'Pozicija je automatski predložena. Uprava još treba provjeriti njezinu točnost.',
    );
  if (clan.status === 'ne')
    napomene.push(jeUprava ? 'Nema pozicije. Upiši koordinate i potvrdi poziciju.' : 'Pozicija priključka još nije upisana.');
  if (clan.bez_broja)
    napomene.push(
      'Nema kućnog broja — poziciju može odrediti samo netko tko poznaje teren.',
    );
  if (clan.napomena) napomene.push(clan.napomena);

  return (
    <section className="kartica" aria-label="Detalji člana">
      <header>
        <div>
          <h3>
            {clan.prezime} {clan.ime}
          </h3>
          <small>
            {clan.adresa ??
              (clan.naselje ? `${clan.naselje} — bez broja` : 'bez adrese')}
          </small>
          <StatusTocke status={clan.status} />
        </div>
        <button className="zatvori" onClick={onZatvori} aria-label="Zatvori">
          ×
        </button>
      </header>

      <dl className="podaci">
        <div>
          <dt>Redni broj u evidenciji</dt>
          <dd>{clan.redni_broj}</dd>
        </div>
        <div>
          <dt>Izvor</dt>
          <dd>Stara bilježnica</dd>
        </div>
        {clan.lat != null && (
          <div>
            <dt>Koordinate</dt>
            <dd className="koordinate-prikaz">
              {Number(clan.lat).toFixed(6)}, {Number(clan.lng).toFixed(6)}
            </dd>
          </div>
        )}
      </dl>

      {napomene.length > 0 && (
        <div className="telo">
          {napomene.map((t, i) => (
            <p key={i}>{t}</p>
          ))}
        </div>
      )}

      {jeUprava ? (
        <UnosKoordinata
          lat={clan.lat}
          lng={clan.lng}
          zauzeto={radi}
          onPotvrdi={(la, ln) => onSpremi(clan, la, ln)}
        >
          {['predlozeno', 'smjesteno'].includes(clan.status) && (
            <button
              className="sek"
              onClick={() => pozovi(onPotvrdi)}
              disabled={radi}
            >
              Pozicija je točna
            </button>
          )}
          {clan.lat != null && (
            <button
              className="sek"
              onClick={() => postaviUklanja(true)}
              disabled={radi}
            >
              Ukloni
            </button>
          )}
        </UnosKoordinata>
      ) : (
        <div className="telo zakljucano">
          Postavljanje pozicije priključka dostupno je upravi.
        </div>
      )}
      {uklanja && jeUprava && (
        <PotvrdaUklanjanja
          radi={radi}
          naOdustani={() => postaviUklanja(false)}
          naPotvrdu={() => pozovi(onUkloni)}
        />
      )}
      {jeUprava && poruka && (
        <div className="unos">
          <p
            className={`poruka ${poruka.vrsta}`}
            role={poruka.vrsta === 'greska' ? 'alert' : 'status'}
          >
            {poruka.tekst}
          </p>
        </div>
      )}
    </section>
  );
}
